import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login";
import PrivateRouter from "./PrivateRouter";
import Dashboard from "./Dashboard";
import Clientes from "./Clientes";
import Empresas from "./Empresas";
import FormularioCliente from "./FormularioCliente";
import Paquetes from "./Paquetes";
import Ordenes from "./Ordenes";
import TasasCambio from "./TasaCambio";
import RecuperarContrasena from "./recuperarContrasena";
import CambiarContrasena from "./CambiarContrasena";
import Usuarios from "./Usuarios";
import InformacionSar from "./InformacionSar";
import Factura from "./Factura";
import ImprimirFactura from "./ImprimirFactura";
import Reporte from "./Reporte";
import Cookies from "universal-cookie";
import LoadingSpinner from "./LoadingSpinner";
import Seguimiento from "./Seguimiento";
import NotFound from "./NotFound";
import Inicio from "./Inicio";
import FAQSection from "./FAQSection";
import TerminosYCondiciones from "./TerminosYCondiciones";
import PoliticasDePrivacidad from "./PoliticasDePrivacidad";
import SolicitudReempaque from "./SolicitudReempaque";
import FormularioReempaquePublico from "./FormularioReempaquePublico";

function Routing() {
  const cookies = new Cookies();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const token = cookies.get("token");
    setIsAuthenticated(!!token);
    setIsInitialized(true);
  }, []);

  const handleLogin = () => {
    const token = cookies.get("token");

    if (token) {
      setIsAuthenticated(true);
    } else {
      console.error("Token no encontrado después del login");
    }
  };

  const handleLogout = () => {
    cookies.remove("token", { path: "/" });
    cookies.remove("nombre_Completo", { path: "/" });
    cookies.remove("correoElectronico", { path: "/" });
    cookies.remove("id_Usuario", { path: "/" });
    setIsAuthenticated(false);
  };

  if (!isInitialized) {
    return <LoadingSpinner />;
  }

  return (
    <BrowserRouter>
    <Routes>
      <Route path='/sistemaMBOX' element={<Login handleLogin={handleLogin} />} />
      
  *    <Route path='/crear-casillero' element={<FormularioCliente />} />
      <Route path='/recuperar-contrasena' element={<RecuperarContrasena />} />
      <Route path='/seguimiento' element={<Seguimiento />} />
      <Route path='/imprimirFactura/:idFactura' element={<ImprimirFactura />} />
      <Route path='/' element={<Inicio />} />
      <Route path='/FAQ' element={<FAQSection />} />
      <Route path='/terminos-y-condiciones' element={<TerminosYCondiciones />} />
      <Route path='/politicas-de-privacidad' element={<PoliticasDePrivacidad />} />
      <Route path='/solicitud-reempaque' element={<FormularioReempaquePublico />} />
  

      <Route element={<PrivateRouter isAuthenticated={isAuthenticated} handleLogout={handleLogout} />}>
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/paquetes' element={<Paquetes />} />
        <Route path='/ordenes' element={<Ordenes />} />
        <Route path='/informacion-sar' element={<InformacionSar />} />
        <Route path='/facturas' element={<Factura />} />
        <Route path='/reportes' element={<Reporte />} />
        <Route path='/clientes' element={<Clientes />} />
        <Route path='/empresas' element={<Empresas />} />
        <Route path='/usuarios' element={<Usuarios />} />
        <Route path='/tasa-cambio' element={<TasasCambio />} />
        <Route path='/reempaques' element={<SolicitudReempaque />} />
      </Route>
  
      <Route path='*' element={<NotFound />} />
    </Routes>
  </BrowserRouter>
  );
}

export default Routing;
